import React, { useContext } from 'react'
import { SimpleSpinner } from '../../../../elem/Spinner'

import AssignedFacilities from './AssignedFacilities'
import AssignmentActions from './AssignmentActions'
import { FacilityAssignmentContext } from './DataContext'
import PossibleFacilities from './PossibleFacilities'
import { DataContext } from '../../DataContext'
import ExpandButton from '../../../../elem/list/ExpandButton'
import { PanelStyleContext } from '../../../../elem/panel/PanelStyleContext'

const Assignment = () => {
    const { viewOnly, isSubmitting } = useContext(DataContext)
    const { loadingConfig } = useContext(FacilityAssignmentContext)
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <div className="column is-12">
            {loadingConfig ? (
                <SimpleSpinner extraClass={'inlineSpinner'} />
            ) : (
                <div className="columns is-multiline assignmentPanelContent">
                    <div className="column is-12">
                        <div className="columns">
                            <div className="column is-1"></div>
                            <div className="column is-10 is-size-4 has-text-centered matchingFacilityText">
                                <span className="has-text-weight-semibold">
                                    Merge Wells
                                </span>
                            </div>
                            <div
                                className="column is-1"
                                style={{ zIndex: 500 }}
                            >
                                <ExpandButton
                                    name={`assignment`}
                                    isExpanded={isExpanded}
                                    setIsExpanded={setIsExpanded}
                                    inHeader={false}
                                />
                            </div>
                        </div>
                    </div>
                    {!viewOnly && (
                        <AssignmentActions isSubmitting={isSubmitting} />
                    )}
                    <div className="column is-12">
                        <div className="assignmentWrapper">
                            <PossibleFacilities />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Assignment
